import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';
import { InternalizationService } from '../config/i18n/i18n.service';
import { find } from 'lodash';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `
})

export class AppComponent implements OnInit {
  languages: any;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private translateService: TranslateService,
              private i18nService: InternalizationService) {
  }

  ngOnInit() {
    // this.setLanguge();
  }

  setLanguge(): void {
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map(route => {
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route;
          }),
          filter(route => route.outlet === 'primary'))
        .subscribe(route => {
          const code = route.snapshot.queryParams.language;
          console.log(route.snapshot);
          const selectedLang = find(this.i18nService.getLanguages(), {shortCode: code});
          if (selectedLang === undefined) {
            this.translateService.use('en');
          } else {
            this.translateService.use(selectedLang.shortCode);
          }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts